import Question from './Question'

export class Switch extends Question {
  get isValueDefault () { return this.defaultValue === this.value }

  get optionId () { return this._questionDefinition.options[0] }

  get option () {
    return this.cartElementBuilder.buildOption(this._questionDefinition.options[0], this.stateObj, this._menu)
  }

  get selectedOption () { return this.value ? this.option : null }
  get selectedOptions () { return this.value ? [this.option] : [] }

  get activeSubQuestions () { return this.selectedOption ? this.selectedOption.questions : [] }

  get currentLevelPrice () { return parseFloat(this.value ? this.option.price : 0) }
  get totalPrice () { return parseFloat(this.value ? this.option.totalPrice : 0) }
  get valueString () { return this.title }
  get valueStringWithTitle () { return this.title + ': ' + (this.value ? '是' : '否') }
  get inValidQuestions () {
    return this.isValid
      ? (this.selectedOption ? this.selectedOption.inValidQuestions : [])
      : [this.title]
  }
}
